module.exports = __webpack_public_path__ + "static/media/26_A.be98c8ce.png";